// extracted by mini-css-extract-plugin
module.exports = {"toDoListContainer":"TodoList_toDoListContainer__Za01B","toDoList":"TodoList_toDoList__3Cjk5","dragTip":"TodoList_dragTip__2Om3K"};